import { QUIZ_STEPS } from '@src/interfaces/state.interfaces';

export const QUIZZES_CONTENT_TYPES = {
  SELECT: 'select',
  INFO: 'info',
  SOCIAL: 'social',
  SELECT_AGE: 'select_age',
  CHOOSE_GENDER: 'choose_gender',
  CURRENT_BODY_TYPE: 'current_body_type',
  TARGET_BODY_TYPE: 'target_body_type',
  AREAS_IMPROVE: 'areas_improve',
  WATER: 'water',
  LOSE_WEIGHT_CHART: 'lose_weight_chart',
  SUSTAINABLE_WEIGHT_CHART: 'sustainable_weight_chart',
  RESTRICTIVE_DIETS: 'restrictive_diets',
  CURRENT_HEIGHT: 'current_height',
  CURRENT_WEIGHT: 'current_weight',
  TARGET_WEIGHT: 'target_weight',
  AGE_INPUT: 'age_input',
  WELLNESS_PROFILE: 'wellness_profile',
  OCCASION: 'occasion',
  PHYSICALLY_ACTIVE: 'physically_active',
  BREAKFAST_TIME: 'breakfast_time',
  LUNCH_TIME: 'lunch_time',
  DINNER_TIME: 'dinner_time',
  EVENT_DATE: QUIZ_STEPS.EVENT_DATE,
  GRAPH: QUIZ_STEPS.GRAPH,
  PLAN: QUIZ_STEPS.PLAN,
  EMAIL: QUIZ_STEPS.EMAIL,
  YOUR_WEIGHT_GRAPH: QUIZ_STEPS.YOUR_WEIGHT_GRAPH,
} as const satisfies Record<string, string>;

export const QUIZZES_CONTENT_TYPES_LIST: readonly string[] = Object.values(
  QUIZZES_CONTENT_TYPES,
);

export const QUIZZES_ANSWERS_TYPES: readonly string[] = [
  QUIZZES_CONTENT_TYPES.SELECT,
  QUIZZES_CONTENT_TYPES.SELECT_AGE,
  QUIZZES_CONTENT_TYPES.CURRENT_BODY_TYPE,
  QUIZZES_CONTENT_TYPES.TARGET_BODY_TYPE,
  QUIZZES_CONTENT_TYPES.AREAS_IMPROVE,
];

export const QUIZZES_PLACEHOLDERS = {
  BMI: /\{\{bmi\}\}/g,
  PERCENTAGE: /\{\{percentage\}\}/g,
} as const;

export const QUIZZES_ALIGN = {
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export const QUIZZES_OCCASION_VALUE_OFFSET = 1;

export const QUIZZES_QUERY_RETRY_COUNT = 2;

export const QUIZZES_BODY_TYPE_TITLES = {
  [QUIZZES_CONTENT_TYPES.CURRENT_BODY_TYPE]: 'questions.step4.title',
  [QUIZZES_CONTENT_TYPES.TARGET_BODY_TYPE]: 'questions.step5.title',
} as const;
